import { useEffect, useState } from "react";
import { isInAppBrowser } from "@/utils/inAppBrowser";

export default function OpenInBrowserBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isInAppBrowser()) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black text-white p-4 z-50 shadow-lg">
      <div className="max-w-lg mx-auto text-center">
        <p className="text-xs mt-2 opacity-70">
          For the best experience, open this page in your browser. Tap ⋮ → Open
          in Browser
        </p>
      </div>
    </div>
  );
}
